export default __webpack_public_path__ + "static/media/alternative_metal_band.857dc47b.png";